export default __webpack_public_path__ + "static/media/imageTum7.e2141bf9.jpg";